import React, { useRef } from "react";
import { Form, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import FilterationBarContainer from "../../../components/FilterationBarContainer";
import CustomReactSelect from "../../../components/CustomReactSelect";

const FilterationBar = (props) => {
	const {
		supervisorsEmpList,
		selectedSupEmp,
		onSupEmpChange,
		leaveTypes,
		selectedLeaveType,
		onLeaveTypeChange,
		startDate,
		endDate,
	} = props;
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<FilterationBarContainer>
			<Col lg={3} className="mb-1">
				<Form.Group className="input-field">
					<Form.Label className="label">Employee</Form.Label>
					<Col>
						<CustomReactSelect
							options={supervisorsEmpList}
							value={selectedSupEmp}
							onChange={(value) => onSupEmpChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>
			<Col lg={3} className="mb-1">
				<Form.Group className="input-field">
					<Form.Label className="label">Leave Type</Form.Label>
					<Col>
						<CustomReactSelect
							options={leaveTypes}
							value={selectedLeaveType}
							onChange={(value) => onLeaveTypeChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>
			<Col lg={3}>
				<Form.Group className="input-field">
					<Form.Label className="label">Start Date</Form.Label>
					<Col className="datepicker-wrapper">
						<DatePicker
							showYearDropdown
							showMonthDropdown
							dateFormatCalendar=" " //for title
							dateFormat="dd/MM/yyyy"
							name="lStartDate"
							className="custom-container"
							onChange={(e) => props.onStartDateChange(e)}
							selected={startDate}
							autoComplete="off"
							maxDate={new Date()}
							ref={startDatepickerRef}
						/>
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="calender-icon"
							color="keppel"
							onClick={() => openStartDatepicker()}
						/>
					</Col>
				</Form.Group>
			</Col>
			<Col lg={3}>
				<Form.Group className="input-field">
					<Form.Label className="label">End Date</Form.Label>
					<Col className="datepicker-wrapper">
						<DatePicker
							showYearDropdown
							showMonthDropdown
							dateFormatCalendar=" " //for title
							dateFormat="dd/MM/yyyy"
							className={"custom-container"}
							selected={endDate}
							onChange={(e) => props.onEndDateChange(e)}
							name="lEndDate"
							minDate={startDate}
							autoComplete="off"
							ref={endDatepickerRef}
						/>
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="calender-icon"
							color="keppel"
							onClick={() => openEndDatepicker()}
						/>
					</Col>
				</Form.Group>
			</Col>
		</FilterationBarContainer>
	);
};

export default FilterationBar;
